module.exports = __webpack_public_path__ + "img/logo-sm.470c1d9c.png";